import {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import { useEmbeddedNavigate } from "../../utils/context/embed";
export const ScreeningPage = () => {
  const navigate = useNavigate();
const embeddedNavigate = useEmbeddedNavigate();


  useEffect(() => {
    embeddedNavigate('/');
  }, [])

  return (
    <div />
  )
}